export default __webpack_public_path__ + "static/media/330_business05-it-web.e99635c1.png";